import { FC, useState, useEffect } from 'react';
import { CustomEditor, ImageUpload, Input, SelectInput } from '../../../commons';
import { useCountries } from '../../../../hooks';
import AccommodationBlocks from './sections/AccommodationBlocks';

interface AccommodationFormProps {
  values: any;
  setFieldValue: any;
}

const ACCOMMODATION_TYPES = [
  { value: 'hotel', label: 'Hotel' },
  { value: 'lodge', label: 'Lodge' },
  { value: 'tented camp', label: 'Tented Camp' },
  { value: 'boutique hotel', label: 'Boutique Hotel' },
  { value: 'resort', label: 'Resort' },
];

const AccommodationForm: FC<AccommodationFormProps> = ({ values, setFieldValue }) => {
  const [initialValue, setInitialValue] = useState(values.description);
  const { countries, loading: countryLoading } = useCountries();

  const handleImageChange = (e: any) => {
    const file = e.target.files[0];
    setFieldValue('file', file);
    const image = URL.createObjectURL(file);
    setFieldValue('imageCover', image);
  };

  useEffect(() => {
    setFieldValue('description', initialValue);
  }, [initialValue]);

  const countriesOptions = countries.map((country: any) => ({
    value: country.id,
    label: country.name,
  }));

  return (
    <div className='space-y-6'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        <Input type='text' name='name' label='Accommodation Name' />
        <Input type='text' name='location' label='Location' />
      </div>

      <Input type='text' name='descriptionTitle' label='Description Title' />

      <div className='space-y-2'>
        <label className='block text-sm font-bold text-gray-700 dark:text-gray-300'>
          Description
        </label>
        <CustomEditor
          placeholder='Type accommodation description here...'
          onChange={setInitialValue}
          value={initialValue}
          name='description'
        />
      </div>

      <SelectInput
        name='type'
        label='Accommodation Type'
        placeholder='Select Type'
        value={values.type}
        setFieldValue={setFieldValue}
        options={ACCOMMODATION_TYPES}
      />

      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 items-start'>
        <div className='md:col-span-2'>
          <SelectInput
            name='country'
            label='Country'
            placeholder='Select Country'
            value={values.country}
            setFieldValue={setFieldValue}
            options={countriesOptions}
            isLoading={countryLoading}
          />
        </div>
        <div className='md:col-span-1'>
          <label className='block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2'>
            Featured Image
          </label>
          <ImageUpload tourImage={values.imageCover} tourImageHandler={handleImageChange} />
        </div>
      </div>

      <AccommodationBlocks values={values} setFieldValue={setFieldValue} />
    </div>
  );
};

export default AccommodationForm;
